//@ts-check
import { makeObservable, observable, action } from 'mobx';

class UsersSyncStore {
    /** @type {{ [x: string]: UserState; }} */
    usersState;
    /** @type {UsersReloadState} */
    usersReloadState;

    constructor() {
        makeObservable(this, {
            usersState: observable,
            usersReloadState: observable
        });
        this.usersState = {};
        this.usersReloadState = {};
    }

    /**
     * @param {{ [x: string]: UserState; }} usersState
     * @param {UsersReloadState} usersReloadState
     */
    SetState(usersState, usersReloadState) {
        this.usersState = usersState;
        this.usersReloadState = usersReloadState;
    }
}

export default new UsersSyncStore();